const tableData = [
    {
        id: 'Lucinda Stickley',
        nameMunicipality: 'Data Coordiator',
        estado: 'Sirnarasa',
        age: 31,
        date: '2018/07/29',
        salary: '$13600'
      }, {
        id: 'Henrietta Carsberg',
        nameMunicipality: 'Data Coordiator',
        estado: 'Paninggaran',
        age: 59,
        date: '2019/07/13',
        salary: '$13700'
      }, {
        id: 'Phylys David',
        nameMunicipality: 'Senior Developer',
        estado: 'New Glasgow',
        age: 52,
        date: '2019/04/08',
        salary: '$15200'
      }, {
        id: 'Brena Shivell',
        nameMunicipality: 'Graphic Designer',
        estado: 'Caen',
        age: 50,
        date: '2018/12/14',
        salary: '$15800'
      }, {
        id: 'Carmon Tuiller',
        nameMunicipality: 'Marketing Assistant',
        estado: 'Jiangbei',
        age: 46,
        date: '2019/06/19',
        salary: '$12800'
      }, {
        id: 'Tina Strattan',
        nameMunicipality: 'Account Representative III',
        estado: 'São Miguel da Carreira',
        age: 31,
        date: '2019/07/08',
        salary: '$13900'
      }, {
        id: 'Jon Tarbox',
        nameMunicipality: 'Senior Cost Accountant',
        estado: 'Ryazhsk',
        age: 61,
        date: '2019/02/22',
        salary: '$16000'
      }, {
        id: 'Carmine Hollibone',
        nameMunicipality: 'Assistant Manager',
        estado: 'Punta del Este',
        age: 50,
        date: '2019/04/23',
        salary: '$15000'
      }, {
        id: 'Cora Germann',
        nameMunicipality: 'Automation Specialist III',
        estado: 'Heshui',
        age: 47,
        date: '2019/03/27',
        salary: '$11300'
      }, {
        id: 'Dawna Hillyatt',
        nameMunicipality: 'Biostatistician I',
        estado: 'Suresnes',
        age: 37,
        date: '2018/12/02',
        salary: '$14800'
      }, {
        id: 'Natty Casini',
        nameMunicipality: 'Senior Developer',
        estado: 'Pucallpa',
        age: 31,
        date: '2018/08/19',
        salary: '$11900'
      }, {
        id: 'Vittorio Lauder',
        nameMunicipality: 'Developer II',
        estado: 'Tønsberg',
        age: 54,
        date: '2018/12/10',
        salary: '$16200'
      }, {
        id: 'Chery Cardenas',
        nameMunicipality: 'Senior Developer',
        estado: 'Santo Tomas',
        age: 26,
        date: '2018/12/07',
        salary: '$11100'
      }, {
        id: 'Hilde McFfaden',
        nameMunicipality: 'Senior Financial Analyst',
        estado: 'Cruz',
        age: 43,
        date: '2018/11/05',
        salary: '$14100'
      }, {
        id: 'Siward Kindred',
        nameMunicipality: 'estado Assistant III',
        estado: 'Béziers',
        age: 39,
        date: '2018/09/26',
        salary: '$15500'
      }, {
        id: 'Tamera Caneo',
        nameMunicipality: 'Executive Secretary',
        estado: 'Hetian',
        age: 38,
        date: '2018/09/28',
        salary: '$12300'
      }, {
        id: 'Munmro Rendell',
        nameMunicipality: 'Marketing Manager',
        estado: 'Castelo',
        age: 60,
        date: '2018/11/15',
        salary: '$12400'
      }, {
        id: 'Nerta Eddisforth',
        nameMunicipality: 'Social Worker',
        estado: 'Al Ḩayfah',
        age: 33,
        date: '2018/12/01',
        salary: '$14900'
      }, {
        id: 'Laraine Hamlyn',
        nameMunicipality: 'Chemical Engineer',
        estado: 'Baška Voda',
        age: 44,
        date: '2019/03/25',
        salary: '$12800'
      }, {
        id: 'Timoteo Lyddy',
        nameMunicipality: 'Recruiting Manager',
        estado: 'Vidago',
        age: 29,
        date: '2018/12/04',
        salary: '$11700'
      }, {
        id: 'Cherye Bleby',
        nameMunicipality: 'Quality Engineer',
        estado: 'La Concordia',
        age: 62,
        date: '2018/10/04',
        salary: '$14700'
      }, {
        id: 'Zacharias O\'Shaughnessy',
        nameMunicipality: 'Senior Editor',
        estado: 'Maungatapere',
        age: 26,
        date: '2018/07/30',
        salary: '$11600'
      }, {
        id: 'Odie Jentin',
        nameMunicipality: 'Programmer II',
        estado: 'Grabovci',
        age: 26,
        date: '2019/05/16',
        salary: '$11200'
      }, {
        id: 'Eugenie Sang',
        nameMunicipality: 'Operator',
        estado: 'Oxbow',
        age: 59,
        date: '2019/07/16',
        salary: '$15200'
      }, {
        id: 'Sammy Guyers',
        nameMunicipality: 'Mechanical Systems Engineer',
        estado: 'Sanhe',
        age: 53,
        date: '2019/07/09',
        salary: '$14200'
      }, {
        id: 'Tarah Blick',
        nameMunicipality: 'Paralegal',
        estado: 'Fylí',
        age: 23,
        date: '2018/12/14',
        salary: '$15200'
      }, {
        id: 'Jemie Ormshaw',
        nameMunicipality: 'Systems Administrator II',
        estado: 'Vila Fria',
        age: 28,
        date: '2019/05/15',
        salary: '$14400'
      }, {
        id: 'Gerrie Semeradova',
        nameMunicipality: 'Research Associate',
        estado: 'Balykchy',
        age: 26,
        date: '2018/09/28',
        salary: '$14900'
      }, {
        id: 'Ottilie Mostyn',
        nameMunicipality: 'Accounting Assistant II',
        estado: 'Eskilstuna',
        age: 43,
        date: '2018/08/20',
        salary: '$11300'
      }, {
        id: 'Lombard Crepin',
        nameMunicipality: 'Project Manager',
        estado: 'Novoul’yanovsk',
        age: 63,
        date: '2019/04/28',
        salary: '$13300'
      }, {
        id: 'Fons Sopp',
        nameMunicipality: 'Structural Analysis Engineer',
        estado: 'Bealanana',
        age: 47,
        date: '2019/02/22',
        salary: '$13300'
      }, {
        id: 'Berenice Wildey',
        nameMunicipality: 'Sales Representative',
        estado: 'Markópoulo Oropoú',
        age: 49,
        date: '2018/10/19',
        salary: '$14700'
      }, {
        id: 'Maybelle Cullotey',
        nameMunicipality: 'Senior Financial Analyst',
        estado: 'Arcos de Valdevez',
        age: 33,
        date: '2019/02/06',
        salary: '$14700'
      }, {
        id: 'Mikkel Lingner',
        nameMunicipality: 'Assistant Media Planner',
        estado: 'Celestynów',
        age: 32,
        date: '2018/08/12',
        salary: '$11400'
      }, {
        id: 'Silvano Hartil',
        nameMunicipality: 'Assistant Manager',
        estado: 'Leles',
        age: 26,
        date: '2019/04/30',
        salary: '$11500'
      }, {
        id: 'Maddi Mansell',
        nameMunicipality: 'Assistant Media Planner',
        estado: 'Doug An',
        age: 48,
        date: '2019/05/29',
        salary: '$14600'
      }, {
        id: 'Mohandas Course',
        nameMunicipality: 'Staff Accountant II',
        estado: 'Wuping',
        age: 59,
        date: '2019/07/18',
        salary: '$12900'
      }, {
        id: 'Ericha Clilverd',
        nameMunicipality: 'Desktop Support Technician',
        estado: 'Conde',
        age: 37,
        date: '2018/09/12',
        salary: '$14400'
      }, {
        id: 'Elspeth Leap',
        nameMunicipality: 'Paralegal',
        estado: 'Hägersten',
        age: 42,
        date: '2019/02/15',
        salary: '$14400'
      }, {
        id: 'Sam Chinge',
        nameMunicipality: 'Assistant Media Planner',
        estado: 'Arai',
        age: 55,
        date: '2019/05/26',
        salary: '$11800'
      }, {
        id: 'Judie Hug',
        nameMunicipality: 'Operator',
        estado: 'Verkhniy Rohachyk',
        age: 32,
        date: '2018/11/18',
        salary: '$11300'
      }, {
        id: 'Lulita Espasa',
        nameMunicipality: 'Operator',
        estado: 'Sabi',
        age: 59,
        date: '2019/06/06',
        salary: '$13600'
      }, {
        id: 'Kandy Fulker',
        nameMunicipality: 'Human Resources Assistant I',
        estado: 'Murowana Goślina',
        age: 57,
        date: '2019/05/01',
        salary: '$13100'
      }, {
        id: 'Bradley Gunbie',
        nameMunicipality: 'Assistant Media Planner',
        estado: 'Bundoran',
        age: 34,
        date: '2019/03/16',
        salary: '$13700'
      }, {
        id: 'Katie Proctor',
        nameMunicipality: 'Quality Engineer',
        estado: 'Qingxi',
        age: 34,
        date: '2018/10/14',
        salary: '$12400'
      }, {
        id: 'Lin Gallaccio',
        nameMunicipality: 'VP Quality Control',
        estado: 'Rongcheng',
        age: 23,
        date: '2018/08/27',
        salary: '$10300'
      }, {
        id: 'Christy Ranaghan',
        nameMunicipality: 'Nurse Practicioner',
        estado: 'Naval',
        age: 42,
        date: '2018/11/02',
        salary: '$15700'
      }, {
        id: 'Concordia Varrow',
        nameMunicipality: 'Environmental Specialist',
        estado: 'Rashaant',
        age: 48,
        date: '2018/12/11',
        salary: '$12500'
      }, {
        id: 'Normand Tropman',
        nameMunicipality: 'Legal Assistant',
        estado: 'Yläne',
        age: 52,
        date: '2019/01/21',
        salary: '$14600'
      }, {
        id: 'Oswald Cruikshank',
        nameMunicipality: 'Help Desk Operator',
        estado: 'Armenia',
        age: 57,
        date: '2019/05/16',
        salary: '$15700'
      }, {
        id: 'Debbie Pinchin',
        nameMunicipality: 'Tax Accountant',
        estado: 'Seara',
        age: 35,
        date: '2018/08/29',
        salary: '$12100'
      }, {
        id: 'Wells Dartan',
        nameMunicipality: 'Financial Analyst',
        estado: 'Bhalwāl',
        age: 44,
        date: '2019/03/03',
        salary: '$10500'
      }, {
        id: 'Kelsey Zucker',
        nameMunicipality: 'Accountant III',
        estado: 'Douz',
        age: 44,
        date: '2018/11/09',
        salary: '$15700'
      }, {
        id: 'Lothaire Rubinchik',
        nameMunicipality: 'Operator',
        estado: 'Paringin',
        age: 37,
        date: '2018/07/26',
        salary: '$13800'
      }, {
        id: 'Dmitri Marrow',
        nameMunicipality: 'Quality Engineer',
        estado: 'Kirzhach',
        age: 30,
        date: '2018/11/25',
        salary: '$13400'
      }, {
        id: 'Virgie Bullivant',
        nameMunicipality: 'Dental Hygienist',
        estado: 'Mungyeong',
        age: 34,
        date: '2019/07/16',
        salary: '$14600'
      }, {
        id: 'Simmonds Moughtin',
        nameMunicipality: 'Programmer III',
        estado: 'Loma',
        age: 44,
        date: '2018/10/20',
        salary: '$13900'
      }, {
        id: 'Ralina Bounds',
        nameMunicipality: 'Associate Professor',
        estado: 'Cacocum',
        age: 52,
        date: '2019/05/12',
        salary: '$11400'
      }, {
        id: 'Bettye Hearons',
        nameMunicipality: 'Food Chemist',
        estado: 'Guayabetal',
        age: 30,
        date: '2018/12/29',
        salary: '$16000'
      }, {
        id: 'Cortie Andreacci',
        nameMunicipality: 'Assistant Manager',
        estado: 'Yongheshi',
        age: 33,
        date: '2018/11/23',
        salary: '$11200'
      }, {
        id: 'Frederic Fozard',
        nameMunicipality: 'Occupational Therapist',
        estado: 'Wierzbica',
        age: 29,
        date: '2019/02/14',
        salary: '$10500'
      }, {
        id: 'Carissa Simeoni',
        nameMunicipality: 'Developer II',
        estado: 'Huansheng',
        age: 29,
        date: '2019/05/21',
        salary: '$13100'
      }, {
        id: 'Ruperto Humblestone',
        nameMunicipality: 'Clinical Specialist',
        estado: 'Zubūbah',
        age: 31,
        date: '2019/07/01',
        salary: '$13200'
      }, {
        id: 'Leontine Sailes',
        nameMunicipality: 'Quality Control Specialist',
        estado: 'Novocherkassk',
        age: 33,
        date: '2018/11/28',
        salary: '$11800'
      }, {
        id: 'Lanny Cregeen',
        nameMunicipality: 'Programmer I',
        estado: 'Abbeville',
        age: 60,
        date: '2018/09/26',
        salary: '$15400'
      }, {
        id: 'Linus Flucker',
        nameMunicipality: 'Help Desk Operator',
        estado: 'Libofshë',
        age: 37,
        date: '2019/03/02',
        salary: '$10300'
      }, {
        id: 'Edd Valentin',
        nameMunicipality: 'Associate Professor',
        estado: 'Vila Chã do Monte',
        age: 42,
        date: '2018/08/26',
        salary: '$14000'
      }, {
        id: 'Rafaela Kingsworth',
        nameMunicipality: 'Senior Sales Associate',
        estado: 'Penco',
        age: 41,
        date: '2019/05/26',
        salary: '$14800'
      }, {
        id: 'Helge Cutajar',
        nameMunicipality: 'Associate Professor',
        estado: 'Wololele A',
        age: 42,
        date: '2019/03/13',
        salary: '$15000'
      }, {
        id: 'Dusty Abethell',
        nameMunicipality: 'Mechanical Systems Engineer',
        estado: 'Bodø',
        age: 36,
        date: '2018/08/30',
        salary: '$15300'
      }
];

export { tableData };
